var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.classificationDescription
        ? _c("div", [
            _c("p", { staticClass: "small mb-2 ml-md-5 mr-4 ml-2" }, [
              _c("span", { staticClass: "text-primary font-weight-bold" }, [
                _vm._v(_vm._s(_vm.$t("global.words.description")) + ":"),
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "document-description ml-2" }, [
                _vm._v(_vm._s(_vm.classificationDescription)),
              ]),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.noDocuments
        ? _c(
            "div",
            { staticClass: "collapsee-body" },
            [
              _c(
                "no-results",
                {
                  staticClass: "d-flex flex-row align-items-center py-4",
                  attrs: { icon: "fa-file" },
                },
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(_vm.$t("documents.thereAreNoDocumentsToShowYet")) +
                      "\n    "
                  ),
                ]
              ),
            ],
            1
          )
        : _vm._l(_vm.documents.byId, function (document) {
            return _c("document-row", {
              key: document.documentId,
              attrs: {
                "uploaded-by": document.uploaderUsername,
                completed: _vm.completed,
                "application-id": _vm.applicationId,
                document: document,
                comments: _vm.getCommentsForDocument(document.documentId),
              },
            })
          }),
      _vm._v(" "),
      !_vm.completed
        ? _c(
            "div",
            {
              staticClass: "row justify-content-center align-items-center mt-3",
            },
            [
              _c(
                "div",
                { staticClass: "col-auto" },
                [
                  _c("input", {
                    ref: "fileInput",
                    staticStyle: { display: "none" },
                    attrs: {
                      type: "file",
                      accept:
                        "application/pdf,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/msword,image/png,image/tiff,image/jpeg",
                      multiple: "",
                    },
                    on: { change: _vm.handleFilesSelected },
                  }),
                  _vm._v(" "),
                  _c(
                    "simple-button",
                    {
                      attrs: {
                        "class-name": "btn-sm upload-from-type",
                        type: "primary",
                        loading: _vm.uploadingDocuments,
                      },
                      on: {
                        click: function ($event) {
                          return _vm.$refs.fileInput.click()
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.$tc("documents.uploadDocument", 1)) +
                          "\n        "
                      ),
                      _c("i", {
                        staticClass: "fa fa-folder-open pl-2",
                        attrs: { "aria-hidden": "true" },
                      }),
                    ]
                  ),
                ],
                1
              ),
            ]
          )
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }